import { SharedEffects } from "./shared.effects";

export const EFFECTS = [
  SharedEffects,
];



// WEBPACK FOOTER //
// ./src/shared/effects/index.ts